import React from "react";
import "assets/css/argon-dashboard-pro-react.css";
import "assets/css/timeline.scss";

const DashboardTheme = () => <React.Fragment></React.Fragment>;

export default DashboardTheme;
